import { render, staticRenderFns } from "./schoolTeacherClass.vue?vue&type=template&id=dc5c1a08&scoped=true&"
import script from "./schoolTeacherClass.vue?vue&type=script&lang=js&"
export * from "./schoolTeacherClass.vue?vue&type=script&lang=js&"
import style0 from "./schoolTeacherClass.vue?vue&type=style&index=0&id=dc5c1a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5c1a08",
  null
  
)

export default component.exports